import FormField from '../../ui/formField';
import { useSelector } from 'react-redux';
import CountryState from '../../ui/countryState';
const BasicInfoSection = (props) => {
  const piFormData = useSelector((state) => state.piData);
  const { loading, error, formData } = piFormData;

  const basicInfoSectionHandler = (e) => {
    props.setBasicInfoSectionData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const basicInfoSection = formData?.data?.basicInfoSection?.map(
    (item, index) => {
      return (
        <FormField
          key={index}
          id={item.id}
          label={item.label}
          type={item.type}
          value={item.value}
          layoutType={item.layoutType}
          name={item.name}
          onChangeHandler={basicInfoSectionHandler}
          selectOptions={item.selectOptions}
          regex={item?.regex}
          errorMessage={item?.errorMessage}
          validationType={item.validationType}
        />
      );
    }
  );
  return <>{basicInfoSection && basicInfoSection}</>;
};
export default BasicInfoSection;
